const searchTypes = {
	questions: "pytan",
	decks: "zestawow",
	articles: "artykulow",
};

const examsPaths = {
	exam: "/egzamin/:id/:questionId?",
	pickExamType: "/egzaminy/typ",
	createExam: "/egzaminy/kreator",
	exams: "/egzaminy",
	examsList: "/egzaminy/lista",
	generateExam: "/egzaminy/generuj",
};

const coursesPaths = {
	createCourse: "/kursy/kreator",
	course: "/kursy/:id/:sectionId?",
	coursesList: "/kursy",
	userCourses: "/kursy/lista",
	pickCourseType: "/kursy/typ",
	courseTemplates: "/kursy/templatki",
};

const flashcardsPaths = {
	flashcards: "/zestawy",
	pickFlashcardsDeckChoice: "/zestawy/wybor",
	deckFlashcardsList: "/zestawy/:deckId/lista",
	userDecks: "/zestawy/lista",
	createDeck: "/zestawy/kreator",
	importDecks: "/zestawy/import",
	flashcardsApp: "/zestawy/:deckId/fiszki",
};

const articlesPaths = {
	article: "/baza-wiedzy/:topic/:id([0-9]+)",
	// stara lista działów → przekierowanie na knowledgeBase (App.jsx)
	articlesLegacy: "/baza-wiedzy/:sectionName?/:tagName?",
};

const foldersPaths = {
	foldersList: "/foldery",
	folder: "/foldery/:id/:type?",
};

const notesPaths = {
	createNote: "/foldery/:id/notatka/utworz",
	editNote: "/foldery/:id/notatka/:noteId/edycja",
	previewNote: "/foldery/:id/notatka/:noteId/podglad",
};

const paths = {
	home: "/",
	lekHome: "/lek",
	pesHome: "/pes",
	ldekHome: "/ldek",
	signIn: "/logowanie/:id?",
	signUp: "/rejestracja",
	resetPassword: "/haslo/reset",
	successResetPassword: "/haslo/wyslano",
	setNewPassword: "/haslo/ustaw",
	setPasswordError: "/haslo/blad",
	notFound: "/404",
	...examsPaths,
	...flashcardsPaths,
	...articlesPaths,
	...coursesPaths,
	...foldersPaths,
	...notesPaths,
	shareDeck: "/zestaw/:code/udostepnij",
	userProfile: "/profil",
	searchQuestion: "/szukaj/:type",
	// Baza wiedzy = szukajka artykułów
	knowledgeBase: `/szukaj/${searchTypes.articles}`,
	redirectSearchQuestion: "/redirect/szukaj/:type",
	chatWidget: "/chat-widget",
	guide: "/poradnik/:sectionId([0-9]+)?",
};

const menuSection = {
	"/egzaminy": paths.exams,
	"/baza-wiedzy": paths.knowledgeBase,
	"/zestawy": paths.flashcards,
	"/kursy": paths.coursesList,
	"/foldery": paths.foldersList,
	"/poradnik": paths.guide,
	"/": paths.home,
};

const routing = {
	paths,
	getUrl: (url, params) => {
		return Object.entries(params).reduce((acc, [key, value]) => {
			const regex = RegExp(`:${key}[?]*`);
			acc = acc.replace(regex, value);
			return acc;
		}, url);
	},
	searchTypes,
	menuSection,
};

export default routing;
